export enum TrackingChannel
{
    Direct = 0,
    Email = 1,
    PaidSearch = 2,
    OrganicSearch = 3,
    Social = 4,
    PaidSocial = 5,
    Banner = 6,
    Affiliate = 7,
    OtherDigital = 8,
    Distributor = 9,
    CustomerService = 10,
    Other = 11,
    RetailerApp = 12,
    Display = 13
}

